import { decodeJwt } from '@/src/shared/lib/jwt';

export const getTokenExpirationMs = (token: string, bufferMs: number = 0): number | null => {
  const decoded = decodeJwt<{ exp: number }>(token);

  if (!decoded || !decoded.exp) {
    return null;
  }

  // exp is in seconds, convert to milliseconds and subtract buffer
  return decoded.exp * 1000 - bufferMs;
};
